export const isEnterKey = (e: React.KeyboardEvent): boolean => {
    return e.key === 'Enter';
};
